import { render } from "./specifications.vue?vue&type=template&id=6b497d9c"
import script from "./specifications.vue?vue&type=script&lang=js"
export * from "./specifications.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__